import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './NoTwitter.css';

const MESSAGES = [
  "We really don't.",
  "Nope. Not even a burner.",
  "We checked. Still no.",
  "This is not a Twitter account.",
  "You found the secret page. Hi.",
  "Still no Twitter. Thanks for asking.",
  "404: Twitter account not found.",
  "We considered it. We didn't do it.",
];

export default function NoTwitter() {
  const [msg, setMsg] = useState(MESSAGES[0]);
  const [clicks, setClicks] = useState(0);

  useEffect(() => {
    setMsg(MESSAGES[clicks % MESSAGES.length]);
  }, [clicks]);

  return (
    <div className="page notwitter-page">
      <div className="notwitter-inner animate-fade-up">

        <div className="notwitter-icon" aria-hidden="true">
          <svg width="52" height="52" viewBox="0 0 52 52" fill="none">
            {/* X / Twitter shape with a cross through it */}
            <rect width="52" height="52" rx="12" fill="#000"/>
            <path d="M10 10 L42 42 M42 10 L10 42" stroke="white" strokeWidth="5" strokeLinecap="round"/>
          </svg>
        </div>

        <h1 className="notwitter-title">We do not have a Twitter account.</h1>

        <p className="notwitter-sub">{msg}</p>

        <button
          className="notwitter-btn"
          onClick={() => setClicks(c => c + 1)}
        >
          Are you sure?
        </button>

        {clicks >= 3 && (
          <p className="notwitter-extra animate-fade-up">
            {clicks >= 7
              ? "Okay you can stop now."
              : clicks >= 5
              ? "We admire your persistence."
              : "Yes. We are very sure."}
          </p>
        )}

        <div className="notwitter-links">
          <Link to="/home" className="btn btn--outline btn--sm">← Go home</Link>
          <a
            href="https://discord.gg/permsystems"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--dark btn--sm"
          >
            We do have a Discord though
          </a>
        </div>

      </div>
    </div>
  );
}
